import { render } from "./contractus.vue?vue&type=template&id=7d9aae66&scoped=true"
import script from "./contractus.vue?vue&type=script&lang=js"
export * from "./contractus.vue?vue&type=script&lang=js"

import "./contractus.vue?vue&type=style&index=0&id=7d9aae66&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9aae66"]])

export default __exports__